export const ALLOWED_ATTACHMENTS_FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
